import { authors } from "../data/author";
import type { ProcessArgs } from "./parser";
import * as cheerio from "cheerio";

export function wrapChat(
  element: cheerio.Element,
  authorId: "k2ek1e" | "uc6o6u5co",
  args: ProcessArgs,
): void {
  const { content } = args;
  const $ = cheerio.load(content);

  const parent = $(element).parent();
  const text = $(element).text();

  const author = authors.find((author) => author.id === authorId);

  $(parent).replaceWith(`<div class="chat chat-start my-4 md:my-8">
    <div class="chat-image avatar">
      <div class="w-10 rounded-full">
        <img alt="Author avatar"
          src="${author?.imageUrl}" />
      </div>
    </div>
    <div class="chat-bubble chat-bubble-primary text-sm">${text}</div>
  </div>`);
}
